import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	formData: [
		{
			job_type_id: null
		}
	],
	dataForServer: {},
	isLoading: false,
	showTokenExpiredMessage: false,
	jobNotAvailable: false,
	jobNotFound: false,
	jobAvailable: false,
	captureSuccess: false,
	captureFailed: false,
	id: '',
	confirm_type_id: '',
  vendorAvailable: false,
  vendorBooked: false,
	availabilityData: {},


}

const getters = {
	/*
	 * Returns formData
	 */
	getFormData (state, {formData}) {
		return state.formData
	},

	/*
	 * Job has been filled
	 */
	checkJobNotAvailable(state){
		return state.jobNotAvailable;
	},

	/*
	 * Job not found
	 */
	checkJobNotFound(state){
		return state.jobNotFound;
	},

	/*
	 * Job found and available
	 */
	checkJobAvailable(state){
		return state.jobAvailable;
	},

	/*
	 * Show success message
	 */
	checkCaptureSuccess(state){
		return state.captureSuccess;
	},

	/*
	 * Show failed message
	 */
	checkCaptureFailed(state){
		return state.captureFailed;
	}
}


// mutations
const mutations = {
	/**
	 * Mutate any boolean variable
	 * @param {string}
	 * @param {boolean}
	 */
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	/**
	 * Set object for push to API
	 */
	SET_DATA_FOR_SERVER(state, {key, value}){			
		// append/update dataForServer
		state.dataForServer[key] = value;

		// need to set formData
		state.formData[key] = value;
	},

	/**
	 * Mutate variables
	 */
	SET_VARIABLE(state, {key, value}){
		eval('state.' + key + ' = value');
	},

	/**
	 * Reset vuex
	 */
	RESET_DATA_FOR_SERVER(state){
		state.dataForServer = {}
		state.formData = {}
	},

	/**
	 * Set formData
	 */
	SET_FORM_DATA (state, {formData}){
		state.formData = formData
	},

}

// actions
const actions = {
	/**
	 * Toggle boolean keys
	 * @param {string}
	 * @param {boolean}
	 */
	toggleBooleanState({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},
	/**
	 * Set variable
	 * @param {string}
	 * @param {boolean}
	 */
	setVariable({commit}, {key, value}){
		commit('SET_VARIABLE', {key: key, value: value});
	},

	/**
	 * Action to set dataForServer object
	 */
	 updateDataForServer({commit}, key, value){
		commit('SET_DATA_FOR_SERVER', key, value)
	},

	/**
	 * Check if job is still available
	 */
	checkToken({commit, dispatch, rootState}, data){
		var id = data.id;
		var url = rootState.auth.l+'check-job';
		// save id to data store for later use.
		commit('SET_VARIABLE', {key: 'id', value: id})
		// pass it to api and check to make sure token exist & is not expired
        axios.post(url, data)
        .then(response => {
        	if(typeof(response.data.status) !== 'undefined'){						
						var ndata = typeof(response.data.data) !== 'undefined' ? response.data.data.original.data : [{job_type_id: null}];
						var availData = typeof(response.data.availability) !== 'undefined' ? response.data.availability : '';
        		commit('SET_FORM_DATA', {formData: ndata});
        		commit('SET_VARIABLE', {key: 'availData', value: availData});

        		switch(response.data.status){
        			// No result
        			case '400':
        				commit('TOGGLE_BOOLEAN_STATE', {key: 'jobNotFound', bool: true});
        				break;
        			// Token has expired
        			case '404':
        				commit('TOGGLE_BOOLEAN_STATE', {key: 'jobNotAvailable', bool: true});
        				break;
        			// Availability already saved
        			case '410':
        				commit('TOGGLE_BOOLEAN_STATE', {key: 'captureSuccess', bool: true});
								var data = response.data.data.original.data;
								var availData = response.data.availability;
								commit('SET_FORM_DATA', {formData: data});
								commit('SET_VARIABLE', {key: 'availabilityData', value: availData})
        				break;
        		}
        	} else {
        		commit('TOGGLE_BOOLEAN_STATE', {key: 'jobAvailable', bool: true});
        		var data = response.data.data;
        		commit('SET_FORM_DATA', {formData: data});
        	}
        })   
        .catch((error) => {
        	console.log(error);
        });
	},

	/**
	 * Capture vendor's availability
	 */
	saveData({commit, dispatch, rootState, state}, val){
		var id = state.id;
		var confirm_type_id = state.confirm_type_id;
		var formData = state.formData;
		var bool;
		switch(val){
			case 'Yes':
				bool = true;
        commit('TOGGLE_BOOLEAN_STATE', {key: 'vendorAvailable', bool: true});
				const availData = {'is_avail': 1}
				commit('SET_VARIABLE', {key: 'availabilityData', value: availData})
				break;
			case 'No':
				bool = false;
        commit('TOGGLE_BOOLEAN_STATE', {key: 'vendorBooked', bool: true});
				break;
		}

		var data = {
			is_avail: bool,
			confirm_type_id: confirm_type_id
		}

		var url = rootState.auth.l+'capture/'+id;

		// pass it to api and check to make sure token exist & is not expired
        axios.put(url,data)
        .then(response => {
			commit('TOGGLE_BOOLEAN_STATE', {key: 'jobAvailable', bool: false});
			commit('TOGGLE_BOOLEAN_STATE', {key: 'captureSuccess', bool: true});
        })   
        .catch((error) => {
			commit('TOGGLE_BOOLEAN_STATE', {key: 'captureFailed', bool: true});
        });
	},

	/**
	 * Clear vuex variables
	 */
	clear({commit, dispatch}){
		commit('RESET_DATA_FOR_SERVER');			// clear dataForServer
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}